export default __webpack_public_path__ + "static/5-119d680965eb0d6c234177a27d7fb727.jpeg";